import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Scrollbar, FreeMode, Manipulation, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
import 'swiper/css/keyboard';
import 'swiper/css/grid';
import 'swiper/css/autoplay';

const SECTION_ID = 'image-gallery-section';
const SWIPER_CLASS = 'image-gallery';

class SwiperImageGallerySection {
    constructor() {
        this._section = document.getElementById(SECTION_ID);
        this._section && this._run();
    }
    _run = () => {
        this._swiper = this._section.querySelector(`.${SWIPER_CLASS}`);

        if (this._swiper) {
            if (innerWidth >= screenSm) {
                this._interval = this._swiper.dataset.interval * 1000;
            } else {
                this._interval = 0;
            }

            this._activateSwiper();
        }
    };

    _activateSwiper = () => {
        this._newsSectionSwiper = new Swiper(this._swiper, {
            modules: [Navigation, Pagination, Keyboard, Autoplay],
            speed: 1000,
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: false,
            grabCursor: true,
            allowTouchMove: true,
            autoHeight: false,
            autoplay: this._interval
                ? {
                      delay: this._interval,
                      pauseOnMouseEnter: false,
                  }
                : false,

            breakpoints: {
                [screenSm]: {
                    // allowTouchMove: false,
                    // centeredSlides: true,
                    // loop: true,
                },
            },
            keyboard: {
                enabled: true,
            },
        });
    };
}

const swiperImageGallerySection = new SwiperImageGallerySection();
